export default __webpack_public_path__ + "static/media/logo.e25f8979.svg";